// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const PHONE = "Telef\u00f3n";
export const SIGNUP_AVATAR = "Profilov\u00e1 fotka";
export const SIGNUP_TITLE = "Registr\u00e1cia";
